var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPelotaBlanca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.77666 10.8762L10.0422 14.625H14.0071L15.2242 10.877L12.0185 8.55879L8.77666 10.8762ZM11.9815 1.5C6.20866 1.5 1.5 6.20039 1.5 12C1.5 17.7996 6.20866 22.5 12.0185 22.5C17.8283 22.5 22.5 17.7996 22.5 12.0369C22.5 6.27422 17.8283 1.5 11.9815 1.5ZM19.3814 16.3107L15.1124 16.246L13.8522 20.3279C13.2593 20.4574 12.6471 20.5312 12.0185 20.5312C11.3898 20.5312 10.778 20.4585 10.1876 20.329L8.92868 16.2492L4.65678 16.3107C4.04333 15.271 3.63821 14.0955 3.51453 12.8359L7.0181 10.3758L5.63754 6.34395C6.45314 5.42766 7.45856 4.68486 8.59751 4.1857L12.0185 6.75L15.4407 4.18775C16.5797 4.68691 17.5851 5.4293 18.4007 6.346L17.0189 10.3758L20.5208 12.8355C20.3634 14.0959 19.9936 15.273 19.3814 16.3107Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPelotaBlanca);
export default __webpack_public_path__ + "static/media/pelota-blanca.6fd9129b07ace6e1c6544c728bc79f15.svg";
export { ForwardRef as ReactComponent };